module.exports = __webpack_public_path__ + "media/follage2.d975f06e.mp4";